import React, { FC } from 'react';
import { SLegalText } from './styles';

interface LegalTextProps {
    html: string;
}

const LegalText: FC<LegalTextProps> = ({ html }) => <SLegalText dangerouslySetInnerHTML={{ __html: html }} />;

export default LegalText;
